import { supabase } from '@/lib/supabase';

export async function getUserSetting<T = any>(userId: string, key: string): Promise<T | null> {
  if (!userId) return null;
  const { data, error } = await supabase
    .from('user_settings')
    .select('value')
    .eq('user_id', userId)
    .eq('key', key)
    .maybeSingle();
  if (error || !data) return null;
  return (data.value as T) ?? null;
}

export async function setUserSetting(userId: string, key: string, value: any): Promise<void> {
  if (!userId) return;
  await supabase
    .from('user_settings')
    .upsert(
      { user_id: userId, key, value, updated_at: new Date().toISOString() },
      { onConflict: 'user_id,key' },
    );
}
